import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import SmartCardBackground from "./SmartCardBackground";

export default function SmartCardBusiness({
  businessName,
  industry,
  subCategory,
  cardNumber,
  tier = "Silver",
  isVerified = false,
  qrCodeUrl,
  photoUrl,
  cardValidity,
  showLogo = false,
  status = "Verified",
  country = "United States",
}) {
  return (
    <div className="relative h-56 w-96 overflow-hidden rounded-2xl border-2 border-white p-3 text-sm shadow-xl">
      {/* ✅ BACKGROUND IMAGE */}
      <SmartCardBackground tier={tier} />

      {/* ✅ CONTENT ABOVE BACKGROUND */}
      <div className="relative z-10">
        {/* Header */}
        <div className="flex items-center gap-2 text-lg font-bold uppercase text-white">
          <span>{tier} Member</span>
        </div>

        {/* Main Info */}
        <div className="mt-2">
          <div className="text-xl font-bold text-white">{businessName}</div>

          <div className="mt-1 text-white/90">
            {industry}
            {subCategory ? ` | ${subCategory}` : ""}
          </div>

          <div className="mt-3 font-mono text-2xl font-bold tracking-widest text-white drop-shadow">
            {cardNumber}
          </div>

          {/* Meta */}
          <div className="mt-5 space-y-1 text-sm text-white/90">
            <div>
              <strong>LOC:</strong> {country} &nbsp; | &nbsp;
              <strong>Valid:</strong> {cardValidity}
            </div>

            <div className="flex items-center gap-2">
              <span>Status:</span>
              <span className="font-semibold">{status}</span>
              <span className="text-green-400">★★★★★</span>
            </div>
          </div>
        </div>
      </div>

      {/* QR / PHOTO */}
      <div className="absolute bottom-4 right-4 z-10 flex flex-col items-end gap-1">
        {photoUrl && (
          <img
            src={photoUrl}
            alt="Profile"
            className="mb-10 h-20 w-20 rounded-2xl border-2 border-white bg-white object-cover shadow-md"
          />
        )}

        {(qrCodeUrl || isVerified) && (
          <div className="-mb-3 mt-4 flex items-center gap-2 rounded-lg bg-white/90 px-1 py-1 text-xs font-semibold text-green-800 shadow-sm">
            {qrCodeUrl && <QRCodeCanvas value={qrCodeUrl} size={40} />}
            {showLogo && (
              <img
                src="/assets/images/m2t-logo.png"
                alt="M2T"
                className="h-10 w-10 rounded-lg bg-white"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
